/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2024, Zumper
 */

/**
 * Checks whether the parameter is an object that has the given property
 */
export function has<Field extends string>(
  err: unknown,
  field: Field
): err is { [key in Field]: unknown } {
  return typeof err === 'object' && !!err && field in err
}
